import React, { Component } from 'react'
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'


type IconSize = 'extraSmall' | 'small' | 'medium' | 'large'
export type IconColor = 'dark' | 'gray' | 'light' | 'white' | 'inherit'
type IconSizeRegistery = Record<IconSize, string>
type IconColorRegistery = Record<IconColor, string>

interface IconProps {
  name: string
  size: IconSize
  color: IconColor
  className?: string
  tooltip?: string
  onClick?: () => void
}

export default class Icon extends Component<IconProps> {
  iconSizes: IconSizeRegistery = {
    extraSmall: 'text-base',
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl'
  }

  iconColors: IconColorRegistery = {
    dark: 'text-primary',
    gray: 'text-secondary',
    light: 'text-tertiary',
    white: 'text-white',
    inherit: 'text-inherit'
  }

  constructor (props: IconProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
//action-${name} action-icon
  get className () {
    const { name, size, color, className } = this.props
    const iconClass = `icon ri-${name}-line leading-none `
    const sizeClass = this.iconSizes[size]
    const colorClass = this.iconColors[color]
    const pointerClass = this.props.onClick && 'cursor-pointer'
    return `${iconClass} ${sizeClass} ${colorClass} ${pointerClass} ${className}`
  }

  capitalize(str: String){
    if(str == ""){
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  handleClick () {
    this.props.onClick && this.props.onClick()
  }

  render () {
    return (
      <div>
        <i
          data-tooltip-content={this.capitalize(this.props.tooltip ? this.props.tooltip : "")}
          data-tooltip-id={this.props.name+"-tooltip"}
          className={this.className}
          onClick={this.handleClick} />
        <Tooltip id={this.props.name+"-tooltip"} />  
      </div>  
    )
  }
}
